import { toast } from '../hooks/use-toast';

/**
 * Utility function to replace alert() with toast notifications
 * Works in sandboxed environments where alert() is blocked
 */
export const showNotification = (message, type = 'default') => {
  const config = {
    description: message,
    duration: 5000, // 5 seconds
  };

  switch(type) {
    case 'success':
      toast({
        ...config,
        title: 'Success',
        className: 'bg-green-50 border-green-200',
      });
      break;
    case 'error':
      toast({
        ...config,
        title: 'Error',
        variant: 'destructive',
      });
      break;
    case 'warning':
      toast({
        ...config,
        title: 'Warning',
        className: 'bg-yellow-50 border-yellow-200',
      });
      break;
    case 'info':
    default:
      toast({
        ...config,
        title: 'Info',
      });
      break;
  }
};

// Convenience methods
export const showSuccess = (message) => showNotification(message, 'success');
export const showError = (message) => showNotification(message, 'error');
export const showWarning = (message) => showNotification(message, 'warning');
export const showInfo = (message) => showNotification(message, 'info');
